import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Header, Segment } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import '../../app/common/MediaQuery/responsive-tables.css';
import DynamicTableFrontEnd from '../DynamicTable/DynamicTableFrontEnd';
//import { userLanguage } from "../../app/common/userLanguageSchema/userLanguage";
//import commonStore from "../../app/stores/commonStore";

function VaultMasterTable() {
  const {
    vaultStore,
    userStore: { user },
  } = useStore();
  const { loadVaults, vaultRegistry, vaultitemsByDate, loading } = vaultStore;
  const [showText, setShow] = useState(false);

  useEffect(() => {
    if (vaultRegistry.size <= 1) loadVaults();
  }, [vaultRegistry.size, loadVaults]);

  useEffect(() => {
    setShow(true);
  }, []);
  const tableData: any = [];

  vaultitemsByDate?.forEach((a) => {
    user?.customerName === 'LVP CMS - AM'
      ? tableData?.push({
          id: a.id,
          roomName: a.vaultName,
          roomCode: a.vaultCode,
          roomCountryLocation: a.vaultCountryLocation,
          roomGPSLocation: a.vaultGPSLocation,
          roomContactPersonName: a.vaultContactPersonName,
          roomContactPersonPhone: a.vaultContactPersonPhone,
        })
      : tableData?.push({
          id: a.id,
          vaultName: a.vaultName,
          vaultCode: a.vaultCode,
          vaultCountryLocation: a.vaultCountryLocation,
          vaultGPSLocation: a.vaultGPSLocation,
          vaultContactPersonName: a.vaultContactPersonName,
          vaultContactPersonPhone: a.vaultContactPersonPhone,
        });
  });
  const removeCol =
    'isReceiving,isDelivery,isReceivingOrder,files,assignedUsers,comments,itemHistory,orders,itemDeliveryRequest,inwards,receivings,host,isDeleted,isActive,cast,thumbnail_large,thumbnail_small,groove_type,speed_and_speed_adjustment,number_of_channels_and_sound_channel_map,file_format_name_and_version,analog_media,format_in_terms_of_broadcast_standards,bits_per_sample_and_sampling_description,songs,physcial_format,host,hostUsername,originIndia,itemCreatedAt,inactive,isgoing,ishost';
  const VaultTable = JSON.parse(JSON.stringify(tableData));
  VaultTable.map((i: any) => removeCol.split(',').map((j) => delete i[j]));

  // if (!loadVaults || loading) return <LoadingComponent />;

  return (
    <>
      <div className="large-table-screen">
        <div className="small-table-screen">
          <Segment>
            <Header
              icon="list"
              size="huge"
              dividing
              as="h1"
              content={
                user?.customerName === 'LVP CMS - AM'
                  ? 'View Room '
                  : 'View Vaults'
              }
              sub
              color="grey"
            />
            {showText &&
              (user?.customerName === 'LVP CMS - AM' ? (
                <DynamicTableFrontEnd
                  data={VaultTable}
                  name={'RoomTable'}
                  actiontype={'editdel'}
                  loading={!loadVaults || loading}
                />
              ) : (
                <DynamicTableFrontEnd
                  data={VaultTable}
                  name={'VaultTable'}
                  actiontype={'editdel'}
                  loading={!loadVaults || loading}
                />
              ))}
          </Segment>
        </div>
      </div>
    </>
  );
}

export default observer(VaultMasterTable);
